"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _replace = _interopRequireDefault(require("lodash/replace"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AperzaDataUtil = /*#__PURE__*/function () {
  function AperzaDataUtil() {
    _classCallCheck(this, AperzaDataUtil);
  }

  _createClass(AperzaDataUtil, null, [{
    key: "formatCompanyName",

    /**
     * 企業名を取得
     * @param companyName
     */
    value: function formatCompanyName(companyName, langCode, tradeName, tradeNamePositionCode) {
      var name = companyName;

      if (tradeName) {
        if (langCode === 'ja') {
          //ラベル表示する場合「その他」を含む商号は表示しない
          //When displaying labels, trade names including "Other" are not displayed.
          var _tradeName = (0, _replace.default)(tradeName, /.*その他.*/, '');

          if (parseInt(tradeNamePositionCode) === 1) {
            name = "".concat(_tradeName).concat(companyName);
          } else if (parseInt(tradeNamePositionCode) === 2) {
            name = "".concat(companyName).concat(_tradeName);
          }
        }
      }

      return name;
    }
  }, {
    key: "convertCluezCompanyIdToCompanyContractDisplayId",
    value: function convertCluezCompanyIdToCompanyContractDisplayId(cluezCompanyId) {
      var cluezCompanyIdString = '' + cluezCompanyId;

      if (cluezCompanyIdString.length != 8 && !isNaN(parseInt(cluezCompanyId))) {
        return '1' + cluezCompanyIdString.padStart(7, '0');
      }

      return cluezCompanyId;
    }
  }]);

  return AperzaDataUtil;
}();

exports.default = AperzaDataUtil;